import React, { useEffect, useMemo, useState } from "react";
import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../../firebase";
import {
  DEFAULT_MEMBRI_PAGE_CONTENT,
  MEMBERS_CONTENT_DOC_PATH,
  MembriPageContent,
  mergeMembriContent,
} from "./content";
import "./admin.css";

function parseContent(raw: string): MembriPageContent {
  const parsed = JSON.parse(raw) as Partial<MembriPageContent>;
  return mergeMembriContent(DEFAULT_MEMBRI_PAGE_CONTENT, parsed);
}

export const AdminMembriDeSindicatPage: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [jsonText, setJsonText] = useState("");

  const docRef = useMemo(
    () => doc(db, MEMBERS_CONTENT_DOC_PATH.collection, MEMBERS_CONTENT_DOC_PATH.id),
    []
  );

  useEffect(() => {
    const load = async () => {
      try {
        const snap = await getDoc(docRef);
        if (snap.exists()) {
          const merged = mergeMembriContent(
            DEFAULT_MEMBRI_PAGE_CONTENT,
            snap.data() as Partial<MembriPageContent>
          );
          setJsonText(JSON.stringify(merged, null, 2));
        } else {
          setJsonText(JSON.stringify(DEFAULT_MEMBRI_PAGE_CONTENT, null, 2));
        }
      } catch (error) {
        console.error(error);
        setMessage("Nu am putut incarca configuratia.");
        setJsonText(JSON.stringify(DEFAULT_MEMBRI_PAGE_CONTENT, null, 2));
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [docRef]);

  const handleFormat = () => {
    try {
      const merged = parseContent(jsonText);
      setJsonText(JSON.stringify(merged, null, 2));
      setMessage("JSON valid si formatat.");
    } catch (error) {
      console.error(error);
      setMessage("JSON invalid. Verifica sintaxa inainte de formatare.");
    }
  };

  const handleReset = () => {
    setJsonText(JSON.stringify(DEFAULT_MEMBRI_PAGE_CONTENT, null, 2));
    setMessage("Configuratia a fost resetata la valorile default. Apasa Salveaza pentru persistare.");
  };

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setMessage("");

    try {
      const merged = parseContent(jsonText);
      await setDoc(
        docRef,
        {
          ...merged,
          updatedAt: serverTimestamp(),
        },
        { merge: true }
      );

      setJsonText(JSON.stringify(merged, null, 2));
      setMessage("Configuratia paginii Membri de sindicat a fost salvata.");
    } catch (error) {
      console.error(error);
      setMessage("Eroare la salvare. JSON invalid sau date incomplete.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="admin-membri-wrapper">Se incarca...</div>;
  }

  return (
    <div className="admin-membri-wrapper">
      <h1>Admin - Membri de sindicat</h1>
      <p>
        Editeaza JSON-ul de mai jos pentru a modifica toate textele, linkurile, produsele, pasii,
        FAQ-ul si butoanele din pagina publica.
      </p>

      <form className="admin-membri-form" onSubmit={handleSave}>
        <label htmlFor="membri-json">Configuratie pagina</label>
        <textarea
          id="membri-json"
          className="admin-membri-json"
          value={jsonText}
          onChange={(e) => {
            setJsonText(e.target.value);
            setMessage("");
          }}
          spellCheck={false}
        />

        <div className="admin-membri-actions">
          <button type="button" onClick={handleFormat}>
            Formateaza JSON
          </button>
          <button type="button" onClick={handleReset}>
            Reset default
          </button>
          <button type="submit" disabled={saving}>
            {saving ? "Se salveaza..." : "Salveaza"}
          </button>
        </div>
      </form>

      {message ? <p className="admin-membri-message">{message}</p> : null}
    </div>
  );
};
